/* The rail on a phone: the agent's tables as a row of chips over the open table, People
   first, a + for a new table at the end. Scrolls sideways when they don't fit. */
import React from "react";
import { Plus } from "lucide-react";

import { IconButton } from "@/shared/components/ui-kit";
import { cn } from "@/shared/lib/cn";

import TableTile from "./TableTile";

import type { SpaceTable } from "@/shared/types";

export default function TableChips({ tables, open, onOpen, onNewTable }: {
  tables: SpaceTable[];
  open: string | null;
  onOpen: (tableId: string) => void;
  onNewTable: () => void;
}) {
  return (
    <nav aria-label="Tables" className="md:hidden shrink-0 flex items-center gap-1.5 px-4 py-2 overflow-x-auto no-scrollbar scroll-px-4 border-b hairline bg-[var(--surface-sunk)]">
      {tables.map((table) => (
        <button
          key={table.id}
          type="button"
          aria-current={table.id === open ? "page" : undefined}
          onClick={() => onOpen(table.id)}
          className={cn(
            "press shrink-0 h-8 px-2.5 inline-flex items-center gap-1.5 rounded-[9px] text-[13px]",
            table.id === open
              ? "bg-[var(--surface)] text-[var(--text-primary)] font-medium ring-1 ring-[var(--hairline)] shadow-lift"
              : "text-[var(--text-secondary)] hover:bg-[var(--accent-hover)]",
          )}
        >
          <TableTile system={table.system} size={14} />
          {table.name}
        </button>
      ))}
      <IconButton size="md" aria-label="New table" title="New table" onClick={onNewTable}>
        <Plus className="w-3.5 h-3.5" strokeWidth={1.75} />
      </IconButton>
    </nav>
  );
}
